/* Proutdoor · Header opción B (13-10-2026): botón BUSCAR en el buscador y "Asesoría experta" junto a cuenta y carro. */
(function(){
  function addSubmit(){
    document.querySelectorAll('store-header search-form').forEach(function(sf){
      if (sf.querySelector('.pt-search-submit')) return;
      var b = document.createElement('button');
      b.type = 'submit';
      b.className = 'pt-search-submit';
      b.setAttribute('aria-label', 'Buscar');
      b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg><span>BUSCAR</span>';
      sf.appendChild(b);
    });
  }
  function moveCta(){
    var cta = document.querySelector('store-header .secondary-nav__cta');
    var icons = document.querySelector('store-header .header__icons');
    if (!cta || !icons || icons.contains(cta)) return;
    var wrap = cta.parentElement;
    wrap.classList.add('pt-cta-wrap');
    var account = icons.querySelector('a.header__icon:not(.js-show-search)');
    icons.insertBefore(wrap, account || icons.firstChild);
  }
  function run(){ addSubmit(); moveCta(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  window.addEventListener('load', run);
  var n = 0, t = setInterval(function(){ run(); if (++n >= 10) clearInterval(t); }, 1000);
})();
